import fetch from '@/plugins/fetch'
import queryString from 'query-string'
import jsCookie from 'js-cookie'
import utils from '@/plugins/utils'
import { PREFIX_SOPERATION_API } from '@/service'
const api = {
  getNewCommentList: `${PREFIX_SOPERATION_API}comment/list2.do`, // 最新评论list
  getCZJCommentList: `https://czjcapi.czj100.com/api-c/comment/getEssenceComments.do`, // 成长加商品评论list
  getNewCommentLabelList: `${PREFIX_SOPERATION_API}comment/getCommentLabelList.do` // 类目id
}

export default {
  async getNewCommentList(
    { commit },
    {
      objectId,
      workerCode,
      page,
      size,
      type,
      uid,
      skey,
      property,
      orderBy,
      labelIds,
      scoreType,
      has_image,
      businessId
    }
  ) {
    try {
      const query = queryString.stringify({
        page,
        size,
        workerCode,
        businessId,
        object_id: objectId, // 商品传spuI的  人员传workCode
        show_user: 1, // 用户信息
        show_reply: 1, // 商家评论
        type, // 4商品  6人员
        uid,
        skey,
        property, //  0非折叠  1折叠   2短评
        orderBy: orderBy || 1, // 排序方式： 1默认 2最新
        labelIds, // 标签ID
        scoreType, // 1好评 2中评 3差评
        has_image: has_image || 0 // 是否只显示有图评论，默认0，1-只显示有图  0-所有
      })
      const comments_res = await fetch(`${api.getNewCommentList}?${query}`)
      const commentsJson = await comments_res.json()
      if (+commentsJson.code === 1) {
        if (page === 1) {
          commit('reSetComments', [])
        }
        commit('setComments', commentsJson.data.list)
        commit('setCommentCount', commentsJson.data.count)
        commit('setCommentPraiseRate', commentsJson.data.praiseRate)
      }
      return commentsJson
    } catch (e) {
      console.log(e)
    }
  },
  async getCZJCommentList(
    { commit },
    { objectId, page, size, type, uid, skey }
  ) {
    try {
      const query = queryString.stringify({
        objectId,
        page,
        size,
        type,
        uid,
        skey
      })
      console.log('query :>> ', query)
      const comments_res = await fetch(`${api.getCZJCommentList}?${query}`)
      const commentsJson = await comments_res.json()
      if (+commentsJson.code === 1) {
        if (page === 1) {
          commit('reSetComments', [])
        }
        commit('setComments', commentsJson.data.list)
        commit('setCommentCount', commentsJson.data.count)
        commit('setCommentPraiseRate', commentsJson.data.praiseRate)
      }
      return commentsJson
    } catch (e) {
      console.log(e)
    }
  },
  async getNewCommentLabelList({ commit }, { category4Id, rid }) {
    try {
      const query = queryString.stringify({
        category4Id,
        rid
      })
      const res = await fetch(`${api.getNewCommentLabelList}?${query}`)
      const resJson = await res.json()
      return resJson
    } catch (e) {
      console.log(e)
    }
  }
}
